<template>
  <span>
    <!-- Grupo do participante -->
    <span class="badge badge-soft-secondary font-size-12 group-badge">{{ ownGroupName }}</span>

    <!-- Grupo herdado do principal (só acompanhante) -->
    <span
      v-if="isCompanion && inheritedName"
      class="badge badge-soft-secondary font-size-12 group-badge ml-1"
      title="Grupo herdado do participante principal"
    >
      <i class="bx bx-link-alt"></i> {{ inheritedName }}
    </span>
  </span>
</template>

<script>
/**
 * Exibe o(s) badge(s) de grupo de um participante.
 * - Sempre o grupo do participante.
 * - Se for acompanhante (ref_id preenchido), um 2º badge com o grupo herdado
 *   do principal (inherited_group), com ícone de vínculo e mesmo estilo.
 */
export default {
  name: 'GroupBadges',
  props: {
    participant: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ownGroupName () {
      const g = this.participant && this.participant.group
      if (g && g.data && g.data.name) return g.data.name
      if (g && g.name) return g.name
      return 'SEM GRUPO'
    },
    isCompanion () {
      return !!(this.participant && this.participant.ref_id)
    },
    inheritedName () {
      const ig = this.participant && this.participant.inherited_group
      return ig && ig.name ? ig.name : null
    }
  }
}
</script>

<style scoped>
.group-badge {
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 260px;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
}
</style>
